import { jsx } from 'react/jsx-runtime';
import { IconBase } from '../../node_modules/react-icons/lib/iconBase.js';

const MdCloseSmall = props => {
  return /*#__PURE__*/jsx(IconBase, {
    viewBox: "0 -960 960 960",
    ...props,
    children: /*#__PURE__*/jsx("path", {
      d: "m336-280-56-56 144-144-144-143 56-56 144 144 143-144 56 56-144 143 144 144-56 56-143-144-144 144Z"
    })
  });
};
const MdDraft = props => {
  return /*#__PURE__*/jsx(IconBase, {
    viewBox: "0 -960 960 960",
    ...props,
    children: /*#__PURE__*/jsx("path", {
      d: "M240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z"
    })
  });
};
const MdFileCopyNew = props => {
  return /*#__PURE__*/jsx(IconBase, {
    viewBox: "0 -960 960 960",
    ...props,
    children: /*#__PURE__*/jsx("path", {
      d: "M760-200H320q-33 0-56.5-23.5T240-280v-560q0-33 23.5-56.5T320-920h280l240 240v400q0 33-23.5 56.5T760-200ZM560-640v-200H320v560h440v-360H560ZM160-40q-33 0-56.5-23.5T80-120v-560h80v560h440v80H160Zm160-800v200-200 560-560Z"
    })
  });
};

export { MdCloseSmall, MdDraft, MdFileCopyNew };
